import AcordeonComponent from "./src/components/acordeon-component";
import AlternadorDespliegue from "./src/classes/alternador-despliegue";
import AttachmentContainerComponent from "./src/components/attachment-container-component";
import BotonInicio from "./src/classes/boton-inicio";
import BotonModal from "./src/classes/boton-modal";
import CarouselComponent from "./src/components/carousel-component";
import FileUploaderComponent from "./src/components/file-uploader-component";
import * as Utils from "./src/utils";
import ListaNotas from "./src/classes/lista-notas";
import Menu from "./src/classes/menu";
import RichTextComponent from "./src/components/rich-text-component";
import VerMas from "./src/classes/ver-mas";

const configurarImpresion = () => {
    const elementosImpresion = document.querySelectorAll("[data-action='imprimir']");
    for (const elemento of elementosImpresion) {
        elemento.addEventListener("click", Utils.print);
    }
};

const configurarModal = () => {
    window.botonesModal = [];
    const botonesModal = document.querySelectorAll(":is([data-action='abrir-modal'], [data-action='cerrar-modal'])");
    let esBotonApertura;

    for (const boton of botonesModal) {
        esBotonApertura = boton.getAttribute("data-action") === "abrir-modal";
        window.botonesModal.push(new BotonModal(boton, esBotonApertura));
    }
};

const configurarMenus = () => {
    window.menus = [];
    const menus = document.querySelectorAll("[role='menubar']");

    for (const menu of menus) {
        window.menus.push(new Menu(menu));
    }
};

const configurarAlternadores = () => {
    window.alternadores = [];
    const alternadores = document.querySelectorAll("[data-action='alternar-despliegue']");
    for (const alternador of alternadores) {
        window.alternadores.push(new AlternadorDespliegue(alternador));
    }
};

const configurarIrArriba = () => {
    window.irArriba = [];
    const botonesArriba = document.querySelectorAll("[data-action='ir-arriba']");
    for (const botonArriba of botonesArriba) {
        window.irArriba.push(new BotonInicio(botonArriba));
    }
};

const configurarListaNotas = () => {
    window.listasNotas = [];
    const listas = document.querySelectorAll(".pm-display .lista-notas[data-section]");
    for (const lista of listas) {
        window.listasNotas.push(new ListaNotas(lista));
    }
}

/*const configurarCargarMas = () => {
 window.cargarMas = [];
 const botonesCarga = document.querySelectorAll("[data-action='cargar-mas']");
 for (const botonCarga of botonesCarga) {
 window.cargarMas.push(new BotonPagina(botonCarga));
 }
 };*/

const configurarVerMas = () => {
    window.elementosVerMas = [];
    const alternantes = document.querySelectorAll("[data-element='toggle-class']");
    for (const alternante of alternantes) {
        window.elementosVerMas.push(new VerMas(alternante));
    }
}

const configurarFormularios = () => {
    const formularios = document.querySelectorAll("form[data-confirm]");
    for(const formulario of formularios) {
        formulario.addEventListener("submit", Utils.confirmFormSubmit);
    }
};

const configurar = () => {
    document.documentElement.classList.remove("no-js");
    customElements.define("acordeon-component", AcordeonComponent);
    customElements.define("attachment-container", AttachmentContainerComponent);
    customElements.define("carousel-component", CarouselComponent);
    customElements.define("file-uploader", FileUploaderComponent);
    customElements.define("richtext-editor", RichTextComponent);

    configurarMenus();
    configurarModal();
    configurarAlternadores();
    configurarIrArriba();
    configurarListaNotas();
    //configurarCargarMas();
    configurarImpresion();
    configurarFormularios();
    configurarVerMas();
};

/*document.addEventListener("DOMContentLoaded", () => {
    configurar();
});*/
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", configurar);
} else {
  configurar();
}
